import React from "react";
import styled from "styled-components";

import { getThemeColor, getFontFamily } from "../../utils";

const greyDient =
  "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)";

export default styled.div`
  background: ${getThemeColor(greyDient)};
  position: relative;
  transition: background 1s;
`;



// WEBPACK FOOTER //
// ./src/components/blocks/Background.js